/*
  Date sorting for the blog index.

  This runs in the browser rather than in Liquid because Shopify offers no
  sort for blog.articles, and Liquid cannot read a custom query parameter, so
  there is no server-side way to honour a ?sort= choice. It therefore reorders
  the cards already rendered on the page: with pagination on, that means the
  current page, not the whole blog.

  Each card carries data-published as a unix timestamp, so no date parsing is
  involved. The default document order is newest-first from Liquid, which is
  what a crawler sees.
*/
(function () {
  function sortGrid(grid, order) {
    var items = Array.prototype.slice.call(grid.children);
    items.sort(function (a, b) {
      var pa = parseInt(a.getAttribute('data-published'), 10) || 0;
      var pb = parseInt(b.getAttribute('data-published'), 10) || 0;
      return order === 'oldest' ? pa - pb : pb - pa;
    });
    // Re-appending an existing node moves it, so this reorders in place.
    items.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  document.querySelectorAll('[data-blog-sort]').forEach(function (select) {
    var grid = document.getElementById(select.getAttribute('data-grid'));
    if (!grid) return;

    // Restore a shared or reloaded ?sort= choice.
    var initial = new URLSearchParams(window.location.search).get('sort');
    if (initial === 'oldest' || initial === 'newest') {
      select.value = initial;
      sortGrid(grid, initial);
    }

    select.addEventListener('change', function () {
      var order = select.value;
      sortGrid(grid, order);

      // Keep the URL shareable without reloading. Liquid never reads this;
      // only the code above does.
      var url = new URL(window.location.href);
      if (order === 'newest') {
        url.searchParams.delete('sort');
      } else {
        url.searchParams.set('sort', order);
      }
      window.history.replaceState({}, '', url);
    });
  });
})();
